import { render, staticRenderFns } from "./CreateStrategicQuestion.vue?vue&type=template&id=3363217c&scoped=true"
import script from "./CreateStrategicQuestion.vue?vue&type=script&lang=js"
export * from "./CreateStrategicQuestion.vue?vue&type=script&lang=js"
import style0 from "./CreateStrategicQuestion.vue?vue&type=style&index=0&id=3363217c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363217c",
  null
  
)

export default component.exports